import React, { Component } from "react";
import { backSplash } from "../Templates/icons";
import { WebSocketEventEmitter } from "../Websockets/WebSocketEventEmitter";
import CircularProgress from '@material-ui/core/CircularProgress';
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { toUUID } from "to-uuid";

class LogInPage extends Component {
  state = {
    username: "",
    password: "",
    processing:false,
    triedOnce:false,
    // attempts: 5,
    //count: Number(localStorage.getItem("count"))
  };

  checkKey = (e) => {
    if (e.keyCode === 13) {
      //checks whether the pressed key is "Enter"
      this.handleClick(e);
    }
  };

  componentDidMount = () => {
    var passwordInput = document.getElementById("password");
    var usernameInput = document.getElementById("username-input");
    passwordInput.addEventListener("keydown", this.checkKey);
    usernameInput.addEventListener("keydown", this.checkKey);
  };

  componentWillUnmount = () => {
    var passwordInput = document.getElementById("password");
    var usernameInput = document.getElementById("username-input");
    passwordInput.removeEventListener("keydown", this.checkKey);
    usernameInput.removeEventListener("keydown", this.checkKey);
  };

  update(field) {
    return (e) =>
      this.setState({
        [field]: e.currentTarget.value,
      });
  }

  handleClick = (e) => {
    e.preventDefault();
    this.setState({processing:true,triedOnce:true})
    const { username, password } = this.state;

    (async () => {
      // We recommend to call `load` at application startup.
      const fp = await FingerprintJS.load();

      // The FingerprintJS agent is ready.
      // Get a visitor identifier when you'd like to.
      const result = await fp.get();
      
      //Use only audio and canvas fingerprinting
      let newResult = {"components":{audio:{},canvas:{}}};
      newResult.components.audio = result.components.audio;
      newResult.components.canvas = result.components.canvas;

      // This is the visitor identifier, generated from the above fingerprinting:
      const visitorId = await FingerprintJS.hashComponents(newResult);

      let user = {
        username: username,
        password: password,
        uuid: toUUID(visitorId),
      };

      const data = {
        eventSource: "user_signin",
        data: {
          sender: username,
          message: `${username} has signed in.`,
          process: "User Activity",
          read: false,
          module: "Log In Form",
          user_id: user.uuid,
          test: "test"
        },
      };
      this.props.login(user).then((res) => {
        if (res) {
          WebSocketEventEmitter.emit("WSInitiator", {});
          WebSocketEventEmitter.emit("WSListener", data);
        }
        else{
          this.setState({processing:false})
        }
      })
      .catch(err=>{
        console.log(err)
        this.setState({processing:false})
      });
    })();
  };

  // Render the session errors if there are any
  renderErrors = (errors) => {

    if (errors && !Array.isArray(errors)){
     
        return (
          <ul id="form-errors" className="flex-justify-center">
            {/* <li key={`error`}>{errors}</li> */}
            {Object.keys(errors).map((error, i) => (
              <li key={`error-${i}`}>{this.props.errors[error]}</li>
            ))}
            {/* {this.renderWarning(this.state.attempts)} */}
          </ul>
        );

    }
  };
    

  // renderWarning = (attempts) => {
  //   if (attempts < 1) {
  //     return <li>{`You have been locked out. ${<br/>} Please contact your system administrator for support`}</li>
  //   }
  //   if (attempts <= 4)
  //   return <li>{`You will be locked out after ${attempts} failed attempts`}</li>
  // }

  render() {
    return (
      <div id='login-page-background' className="flex-centered">
        <div className="login-page-background-svg max-width">
          {backSplash}
        </div>
        <div id='login-form-container' className="flex-column">
          <h1 className="bold">AVARIS</h1>
          <h3>Welcome back!</h3>
          <h3>Please sign in to continue.</h3>
          <form>
            <div id="login-form" className="flex-column">
              <div className="input-box shadow">
                {/* {envelopeIcon} */}
                <input
                  id="username-input"
                  type="text"
                  value={this.state.username}
                  onChange={this.update("username")}
                  placeholder="Username"
                  autoComplete={this.state.rememberMe ? "username" : "none"}
                />
              </div>
              <div className="input-box shadow">
                {/* {lockIcon} */}
                <input
                  id="password"
                  type="password"
                  value={this.state.password}
                  onChange={this.update("password")}
                  placeholder="Password"
                  autoComplete={this.state.rememberMe ? "password" : "none"}
                />
              </div>
              {this.renderErrors(this.props.errors)}
              {this.state.processing ? <CircularProgress/> : 
              <svg className="clickable" onClick={(e) => this.handleClick(e)} width="222" height="63" viewBox="0 0 222 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="222" height="63" rx="5" fill="#081F5F" />
                <path d="M67.4214 34.2139C67.4784 35.2311 67.7184 36.0571 68.1416 36.6919C68.9473 37.88 70.3674 38.4741 72.4019 38.4741C73.3133 38.4741 74.1434 38.3439 74.8921 38.0835C76.3407 37.5789 77.0649 36.6756 77.0649 35.3735C77.0649 34.397 76.7598 33.7012 76.1494 33.2861C75.5309 32.8792 74.5625 32.5252 73.2441 32.2241L70.8149 31.6748C69.228 31.3167 68.105 30.922 67.4458 30.4907C66.3065 29.742 65.7368 28.623 65.7368 27.1338C65.7368 25.5225 66.2943 24.2 67.4092 23.1665C68.5241 22.133 70.1029 21.6162 72.1455 21.6162C74.0254 21.6162 75.6204 22.0719 76.9307 22.9834C78.249 23.8867 78.9082 25.3353 78.9082 27.3291H76.6255C76.5034 26.3688 76.243 25.6323 75.8442 25.1196C75.1037 24.1838 73.8464 23.7158 72.0723 23.7158C70.64 23.7158 69.6105 24.0169 68.9839 24.6191C68.3573 25.2214 68.0439 25.9212 68.0439 26.7188C68.0439 27.5977 68.4102 28.2406 69.1426 28.6475C69.6227 28.9079 70.7091 29.2334 72.4019 29.624L74.9165 30.1978C76.1291 30.4744 77.0649 30.8529 77.7241 31.333C78.8634 32.1712 79.4331 33.3879 79.4331 34.9829C79.4331 36.9686 78.7088 38.3887 77.2603 39.2432C75.8198 40.0977 74.1434 40.5249 72.231 40.5249C70.0011 40.5249 68.2555 39.9552 66.9941 38.8159C65.7327 37.6847 65.1143 36.1507 65.1387 34.2139H67.4214ZM83.0586 22.0679H85.5122V40H83.0586V22.0679ZM97.2188 21.604C98.9033 21.604 100.36 21.9295 101.589 22.5806C103.371 23.5164 104.462 25.1562 104.86 27.5H102.456C102.163 26.1898 101.556 25.2376 100.637 24.6436C99.7171 24.0413 98.5575 23.7402 97.1577 23.7402C95.4976 23.7402 94.0978 24.3628 92.9585 25.6079C91.8273 26.853 91.2617 28.7085 91.2617 31.1743C91.2617 33.3065 91.7297 35.0439 92.6655 36.3867C93.6014 37.7214 95.1273 38.3887 97.2432 38.3887C98.8626 38.3887 100.201 37.9207 101.259 36.9849C102.325 36.0409 102.871 34.519 102.895 32.4194H97.2798V30.4053H105.153V40H103.591L103.005 37.6929C102.183 38.5962 101.455 39.2228 100.82 39.5728C99.7537 40.175 98.3988 40.4761 96.7549 40.4761C94.6309 40.4761 92.8039 39.7884 91.2739 38.4131C89.6056 36.6878 88.7715 34.3197 88.7715 31.3086C88.7715 28.3057 89.5853 25.9172 91.2129 24.1431C92.7591 22.4504 94.7611 21.604 97.2188 21.604ZM108.925 22.0679H111.794L120.852 36.5942V22.0679H123.159V40H120.437L111.245 25.4858V40H108.925V22.0679ZM134.499 22.0679H136.953V40H134.499V22.0679ZM140.908 22.0679H143.776L152.834 36.5942V22.0679H155.141V40H152.419L143.227 25.4858V40H140.908V22.0679Z" fill="white" />
              </svg>}

            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default LogInPage;
